export const VEHICLES = [
  {
    id: "escalade",
    name: "Cadillac Escalade",
    tagline: "The Executive Standard",
    seats: 6,
    image:
      "https://customer-assets.emergentagent.com/job_premium-car-service-10/artifacts/tn5q4iqd_IMG_3346.jpeg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_premium-car-service-10/artifacts/tn5q4iqd_IMG_3346.jpeg",
    ],
    tiers: [
      { minHours: 1, maxHours: 2, label: "1 – 2 HOURS", rate: 150 },
      { minHours: 3, maxHours: 5, label: "3 – 5 HOURS", rate: 135 },
      { minHours: 6, maxHours: 999, label: "6+ HOURS", rate: 120 },
    ],
    wedding: 1000,
    prom: 800,
    additionalHour: 120,
    quoteOnly: false,
  },
  {
    id: "sprinter",
    name: "2026 Sprinter Van",
    tagline: "Group Luxury, Engineered",
    seats: 14,
    image:
      "https://customer-assets.emergentagent.com/job_premium-car-service-10/artifacts/8waoahdu_IMG_4164.jpeg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_premium-car-service-10/artifacts/8waoahdu_IMG_4164.jpeg",
      "https://customer-assets.emergentagent.com/job_premium-car-service-10/artifacts/fikn38ad_IMG_3354.jpeg",
      "https://customer-assets.emergentagent.com/job_premium-car-service-10/artifacts/4tmectd7_IMG_4968.jpeg",
      "https://customer-assets.emergentagent.com/job_premium-car-service-10/artifacts/jbtuftop_IMG_4967.jpeg",
    ],
    tiers: [
      { minHours: 1, maxHours: 2, label: "1 – 2 HOURS", rate: 190 },
      { minHours: 3, maxHours: 5, label: "3 – 5 HOURS", rate: 180 },
      { minHours: 6, maxHours: 999, label: "6+ HOURS", rate: 175 },
    ],
    wedding: 1300,
    prom: 1100,
    additionalHour: 175,
    quoteOnly: false,
  },
  {
    id: "rolls_royce",
    name: "White Rolls Royce",
    tagline: "Iconic. Elegant. Unforgettable.",
    seats: 4,
    image:
      "https://customer-assets.emergentagent.com/job_premium-car-service-10/artifacts/s68gmvf0_IMG_4971.jpeg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_premium-car-service-10/artifacts/s68gmvf0_IMG_4971.jpeg",
    ],
    tiers: [],
    wedding: null,
    prom: null,
    additionalHour: null,
    quoteOnly: true,
    bestFor: ["Weddings", "Proms", "Special Events", "Photoshoots"],
  },
];

export const ADD_ONS = [
  {
    id: "armed_security",
    label: "Armed Security",
    desc: "Your safety is our priority.",
    icon: "ShieldCheck",
  },
  {
    id: "champagne",
    label: "Champagne Service",
    desc: "Celebrate in style.",
    icon: "Wine",
  },
  {
    id: "red_carpet",
    label: "Red Carpet Experience",
    desc: "Make every arrival unforgettable.",
    icon: "Sparkles",
  },
  {
    id: "custom_decor",
    label: "Custom Décor & VIP",
    desc: "Tailored to make your event special.",
    icon: "Gift",
  },
];

export const OCCASIONS = [
  "Wedding",
  "Prom",
  "Birthday",
  "Corporate",
  "Airport Transfer",
  "Night Out",
  "Concert / Event",
  "Photoshoot",
  "Other",
];

export const BRAND = {
  phone: "404-326-0944",
  phoneLink: "tel:+14043260944",
  smsLink: "sms:+14043260944",
  logo: "https://customer-assets.emergentagent.com/job_premium-car-service-10/artifacts/e2xtoss3_IMG_4531.png",
  heroBg:
    "https://images.unsplash.com/photo-1575917649705-5b59aaa12e6b?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  redCarpet:
    "https://images.unsplash.com/photo-1614080035039-af24354a6478?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};
